"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hoverlord = void 0;
const ResourceType_1 = require("../ResourceType");
class Hoverlord {
    constructor() {
        this.name = 'Hoverlord';
        this.description = 'Have at least 7 floater resources on your cards';
    }
    getScore(player) {
        let floaterResources = 0;
        player.getCardsWithResources().filter((card) => card.resourceType === ResourceType_1.ResourceType.FLOATER).forEach((card) => {
            floaterResources += player.getResourcesOnCard(card);
        });
        return floaterResources;
    }
    canClaim(player) {
        return this.getScore(player) >= 7;
    }
}
exports.Hoverlord = Hoverlord;
//# sourceMappingURL=Hoverlord.js.map